import { useState, useCallback } from "react";

const FONT_SIZES = [
  { key: "normal", label: "A", scale: 1.0 },
  { key: "large", label: "A+", scale: 1.15 },
  { key: "xlarge", label: "A++", scale: 1.3 },
];

const STORAGE_KEY = "greidi_font_scale";
const CONTRAST_KEY = "greidi_high_contrast";

function getInitialIndex() {
  try {
    const saved = localStorage.getItem(STORAGE_KEY);
    if (saved) {
      const idx = FONT_SIZES.findIndex((f) => f.key === saved);
      if (idx >= 0) return idx;
    }
  } catch {}
  return 0;
}

function getInitialContrast() {
  try {
    return localStorage.getItem(CONTRAST_KEY) === "true";
  } catch {}
  return false;
}

export default function useFontSize() {
  const [sizeIndex, setSizeIndex] = useState(getInitialIndex);
  const [highContrast, setHighContrast] = useState(getInitialContrast);

  const cycleFontSize = useCallback(() => {
    setSizeIndex((prev) => {
      const next = (prev + 1) % FONT_SIZES.length;
      try {
        localStorage.setItem(STORAGE_KEY, FONT_SIZES[next].key);
      } catch {}
      return next;
    });
  }, []);

  const toggleContrast = useCallback(() => {
    setHighContrast((prev) => {
      const next = !prev;
      try {
        localStorage.setItem(CONTRAST_KEY, String(next));
      } catch {}
      return next;
    });
  }, []);

  const current = FONT_SIZES[sizeIndex];
  return {
    fontScale: current.scale,
    fontLabel: current.label,
    fontKey: current.key,
    cycleFontSize,
    highContrast,
    toggleContrast,
  };
}
